import { Tabs } from 'antd';
import { ForgotPasswordMethod } from 'src/shared/interface/forgot-password';
import { MailOutlined, PhoneOutlined } from '@ant-design/icons';

interface IMethodSelectionProps {
  selectedMethod: ForgotPasswordMethod;
  onMethodChange: (method: ForgotPasswordMethod) => void;
}

export const MethodSelection = ({ selectedMethod, onMethodChange }: IMethodSelectionProps) => {
  const handleTabChange = (key: string) => {
    const methodKey = Number(key) as ForgotPasswordMethod;
    onMethodChange(methodKey);
  };

  return (
    <div className='w-full'>
      <Tabs
        activeKey={String(selectedMethod)}
        onChange={handleTabChange}
        centered
        items={[
          {
            key: String(ForgotPasswordMethod.EMAIL),
            label: (
              <span className='text-base font-medium px-4'>
                <MailOutlined className='text-gray-400' />
                Email
              </span>
            ),
          },
          {
            key: String(ForgotPasswordMethod.SMS),
            label: (
              <span className='text-base font-medium px-4'>
                <PhoneOutlined className='text-gray-400' />
                SMS OTP
              </span>
            ),
          },
        ]}
      />
    </div>
  );
};
